import React from "react";
import { useRootStore } from "../../../../store/contexts";
import { ShowString } from "../../../common/controls";
import {
  useSnapshotExtension,
  useSnapshotExtensionTop,
} from "../../../common/controls";
import { FormControl } from "@mui/material";

type TerritoryViewProps = {
  snapshotData: any;
  // Propagated from the top-level snapshot view so nested tables can resolve
  // the snapshot-scoped file-download endpoint (/<snapshotEntityName>.data/
  // <snapshotRecordId>/<fileUuid>). Both are optional at the type level but
  // required at runtime for the download / view affordances to work.
  snapshotEntityName?: string;
  snapshotRecordId?: string;
};

export const TerritoryView: React.FC<TerritoryViewProps> = ({
  snapshotData,
}) => {
  const { langStore } = useRootStore();
  const renderExtensionTop = useSnapshotExtensionTop("Territory");
  const renderExtension = useSnapshotExtension("Territory");

  return (
    <>
      {renderExtensionTop ? renderExtensionTop(snapshotData) : null}
      <FormControl fullWidth>
        <ShowString
          label={langStore.TerritoryNameLabel}
          value={snapshotData?.[`name_${langStore.language}`] ?? ""}
        />
      </FormControl>
      {renderExtension ? renderExtension(snapshotData) : null}
    </>
  );
};
